module.exports = __webpack_public_path__ + "img/wechat-qr.abb90224.jpg";